export var cibKoding = ["32 32", "<path d='M1.068 0h29.599v8h-29.333v-8zM1.068 12h22.932v8h-23.068v-8zM1.068 24h29.599v8h-29.333v-8z'/>"];
